import AdditionalTesting from "./models/addOnTesting/AdditionalTesting"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getAddOnTesting = (id: number) => ObservableFromFetch<AdditionalTesting>(`AddOnTesting/Advertisements?id=${id}`)
